/* eslint-disable no-continue */
/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, {
    useCallback,
    useEffect,
    useMemo,
    useState,
} from "react";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import { Formik, Form, Field } from "formik";
import PropTypes from "prop-types";
import FormikCreateSearchClear from "src/components/formik/FormikCreateSearchClear";
import FormikDateTimePicker from "src/components/formik/FormikDateTimePicker";
import Table from "src/components/table/Table";
import { set } from "lodash";
import { getEndOfDay, getStartOfDay } from "src/utils/DadeUtils";
import { headerShowAction } from "../header-container/actions/HeaderActions";
import {
    CAR_LOAN_TYPE_LIST,
    USED_CAR_LOAN_TYPE_LIST,
} from "../product-container/ProductConstants";
import CompanyDropDown from "src/business-components/CompanyDropDown";
import UserDropDown from "src/business-components/UserDropDown";
import FormikSelect from "src/components/formik/FormikSelect";
import { ManagerAgentMonthWiseCases } from "src/api/CaseApi";
import { useHistory } from 'react-router';
import RoutingUtil from 'src/utils/RoutingUtil';

const Render = ({
    values,
    setFieldValue,
    monthTotals,
    managerTotalCases,
    ...props
}) => {

    const handleFromDateChange = (rawDate) => {
        // FormikDateTimePicker sends rawDate?.value or rawDate
        const date = rawDate?.value ? new Date(rawDate.value) : new Date(rawDate);
        if (isNaN(date)) return; // invalid date

        // Set From Date
        setFieldValue("CaseFromDate", date);

        // Auto-set To Date (3 months later minus 1 day)
        const toDate = new Date(date);
        toDate.setMonth(toDate.getMonth() + 3);
        toDate.setDate(toDate.getDate() - 1);

        setFieldValue("CaseToDate", toDate);
    };
    const {
        // errors,
        // touched,
        isSubmitting,
        onClear,
        // forceRefreshSearchContainer,
        resetForm,
        // values,
        activityList,
        userType,
        PRODUCT_CATEGORY_TYPES_LIST,
        onPageChange,
        VehicleStatusTypesData,
        handleRouting,
    } = props;

    const monthNames = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];

    // Month names
    const monthWiseTotals = monthTotals || [];

    const monthColumns = useMemo(() => {
        if (!props.onSearchValues?.months?.length) return [];
        return props.onSearchValues.months.map((month, index) => {
            const monthName = monthNames[month - 1];
            const year = new Date(props.onSearchValues.CaseFromDate).getFullYear();
            return {
                display: `${monthName} ${year}`,   // e.g., "Nov 2024"
                path: `M${index + 1}`,       // maps to M1, M2, M3
            };
        });
    }, [props.onSearchValues]);

    const tableData = activityList?.data || [];

    return (
        <div>
            <div style={{ justifyContent: "center", display: "flex", padding: "px" }}>
                <h2>Back End Manager Sales Report</h2>
            </div>
            <div className="card">
                <div className="card-body">
                    <h5 className="card-title">Search Filters</h5>
                    <Form>
                        <div className="form-row">
                            <div className="form-group col-md-3">
                                <label>Category</label>
                                <FormikSelect
                                    items={PRODUCT_CATEGORY_TYPES_LIST}
                                    name="productCategory"
                                    className="form-control"
                                />
                            </div>
                            {values.productCategory === "CAR_LOAN" && (
                                <div className="form-group col-md-3">
                                    <label>Loan Type</label>
                                    <FormikSelect
                                        items={CAR_LOAN_TYPE_LIST}
                                        name="loanType"
                                        className="form-control"
                                    />
                                </div>
                            )}
                            {values.productCategory === "VEHICLE_INSURANCE" && (
                                <div className="form-group col-md-3">
                                    <label>Policy Type</label>
                                    <FormikSelect
                                        items={VehicleStatusTypesData}
                                        name="insuranceType"
                                        className="form-control"
                                    />
                                </div>
                            )}
                            {/* )} */}
                            {/* {values.productCategory === "CAR_LOAN" && */}
                            {values.loanType === "USED" && (
                                <div className="form-group col-md-3">
                                    <label>Used Car Loan Type</label>
                                    <FormikSelect
                                        items={USED_CAR_LOAN_TYPE_LIST}
                                        name="usedCarLoanType"
                                        className="form-control"
                                    />
                                </div>
                            )}
                            <div className="form-group col-md-3">
                                <label>From Date</label>
                                <FormikDateTimePicker
                                    name="CaseFromDate"
                                    className="form-control"
                                    disableClock
                                    format="dd-MM-y"
                                // onChange={(date) => handleFromDateChange(date)}
                                />
                            </div>
                            <div className="form-group col-md-3">
                                <label>To Date</label>
                                <FormikDateTimePicker
                                    name="CaseToDate"
                                    className="form-control"
                                    disableClock
                                    format="dd-MM-y"
                                    disabled={Boolean(values.FilterCommissionId) || Boolean(values.FilterTargetId)}
                                />
                            </div>
                            <div className="form-group col-md-8">
                                <label>BackendManager</label>
                                <UserDropDown name="reportingManagerBackendId" value={values.reportingManagerBackendId} disabled={Boolean(values.FilterTargetId)} />
                            </div>
                        </div>
                        <div className="text-center py-4 mt-3">
                            <FormikCreateSearchClear
                                isSubmitting={isSubmitting}
                                onClear={onClear}
                                resetForm={resetForm}
                                submitButtonText="Search"
                                submitScope="reports.back_end_manager_sales_report.search"
                            // submitScope="reports.sales_report.search"
                            />
                        </div>
                    </Form>
                </div>
            </div >

            <div className="border-top my-3" />

            <div className="card mt-3">
                <div className="card-body">
                    <h5 className="card-title">
                        Search Results
                    </h5>
                </div>

                <div className="d-flex justify-content-end mb-2">
                    <span className="mr-2 border badge badge-secondary status-Total mb-2">
                        <div>
                            <label>Total Cases</label>
                            <div>
                                <input
                                    className="text-center font-weight-bold text-black"
                                    type="text"
                                    value={managerTotalCases}
                                    disabled
                                />
                            </div>
                        </div>
                    </span>
                    {monthWiseTotals.map((item) => (
                        <span key={item.month} className="mr-2 border badge badge-secondary status-Total mb-2">
                            <label>Total Cases of {monthNames[item.month - 1]}</label>
                            <div>
                            <input
                             className="text-center font-weight-bold text-black"
                             type="text"
                             value={item.totalCases} 
                             disabled />
                             </div>
                        </span>
                    ))}
                </div>

                <Table
                    recordsPerPage={50}
                    searchData={{
                        data: tableData,
                        count: tableData.length,
                        currentPage: 0,
                    }}
                    columns={{
                        group: [
                            { display: "Agent Name", path: "agentName" },
                            ...monthColumns,
                        ],
                    }}
                />
            </div>
        </div >
    )
}

Render.propTypes = {
    isSubmitting: PropTypes.bool.isRequired,
    // onClear: PropTypes.func.isRequired,
    // resetForm: PropTypes.func.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    values: PropTypes.any.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    // activityList: PropTypes.Object.isRequired,
};

const today = new Date();

// Get last month
const lastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);

// CaseToDate = last date of last month
const caseToDate = new Date(lastMonth.getFullYear(), lastMonth.getMonth() + 1, 0);
// The 0th day of next month gives the last day of current month

// CaseFromDate = first day of 2 months before last month
const caseFromDate = new Date(lastMonth.getFullYear(), lastMonth.getMonth() - 2, 1);

const filterDefaultValues = {
    productCategory: 'CAR_LOAN',
    CaseFromDate: caseFromDate,
    CaseToDate: caseToDate,
};

console.log("CaseFromDate:", caseFromDate);
console.log("CaseToDate:", caseToDate);


const PRODUCT_CATEGORY_TYPES_LIST = [
    { value: 'VEHICLE_INSURANCE', label: 'Insurance' },
    { value: 'CAR_LOAN', label: 'Car Loan' },
];
const VehicleStatusTypesData = [
    { value: "New", label: 'New' },
    { value: "NEW_ROLLOVER", label: 'New-Rollover' },
    { value: "RENEWAL", label: 'Renewal' },
    { value: "ROLLOVER", label: 'ROLLOVER' },
    // Add other policy types here if necessary
];

const BEMgrSalesReport = () => {
    const history = useHistory();
    const { location: { state } } = history;
    let filters = state?.filters || null;

    const [filterInitialValues, setFilterInitialValues] = useState(filters || {
        ...filterDefaultValues,
    });


    const [searchResults, setSearchResults] = useState(null)
    const [onSearchValues, setOnSearchValues] = useState({})

    const dispatch = useDispatch();
    useEffect(() => {
        if (filters) {
            onSearchSubmit(filters)
        }
        return () => {
            filters = null
        }
    }, [filters])
    const { userType, userId } = useSelector(
        (state) => state.AuthReducer,
        shallowEqual
    );

    // const activitiesFromSearch = useMemo(() => {
    //     if (!searchResults) {
    //         return { data: [], count: 0 };
    //     }
    //     // Flatten manager → agents into individual rows
    //     const flattenedData = searchResults.flatMap((manager) =>
    //         manager.agents.map((agent) => ({
    //             managerId: manager.managerId,
    //             managerName: manager.managerName,
    //             totalCases: manager.totalCases,
    //             M1Total: manager.M1Total,
    //             M2Total: manager.M2Total,
    //             M3Total: manager.M3Total,
    //             agentId: agent.agentId,
    //             agentName: agent.agentName,
    //             M1: agent.M1,
    //             M2: agent.M2,
    //             M3: agent.M3,
    //         }))
    //     );

    //     return {
    //         data: flattenedData,
    //         count: flattenedData.length,
    //     };
    // }, [searchResults]);

    //     let PrepairData = [];
    //     let count = 0;
    //     searchResults.forEach((caseInfo) => {
    //         count++;
    //         PrepairData.push({
    //             ...caseInfo,
    //         });
    //     })
    //     const results = {
    //         data: PrepairData,
    //         count,
    //     }

    //     return results;
    // }, [searchResults])

    const activitiesFromSearch = useMemo(() => {
        if (!Array.isArray(searchResults) || searchResults.length === 0) {
            return { data: [], count: 0 };
        }

        const flattenedData =
            searchResults?.[0]?.managerAgentData?.flatMap((manager) =>
                (manager.agents || []).map((agent) => ({
                    managerId: manager.managerId,
                    managerName: manager.managerName,
                    managerTotalCases: manager.totalCases, // ✅ ADD THIS
                    agentId: agent.agentId,
                    agentName: agent.agentName,
                    M1: agent.M1?.count || 0,
                    M2: agent.M2?.count || 0,
                    M3: agent.M3?.count || 0,
                }))
            ) || [];
        
        return {
            data: flattenedData,
            count: flattenedData.length,
        };
    }, [searchResults]);


    const onClear = () => {

    }
    const onSearchSubmit = useCallback(
        async (values) => {
            const {
                productCategory,
                loanType,
                insuranceType,
                usedCarLoanType,
                CaseFromDate,
                CaseToDate,
                companyId,
                agentId,
                // reportingManagerId,
                reportingManagerBackendId,
            } = values;

            // Check if CaseFromDate and CaseToDate are present
            if ((!productCategory)) {
                dispatch(
                    headerShowAction({
                        data: "Product category is required.",
                    })
                );
                return;
            }
            if ((!CaseFromDate || !CaseToDate)) {
                dispatch(
                    headerShowAction({
                        data: "CaseFromDate and CaseToDate are required filters.",
                    })
                );
                return;
            }
            if (!reportingManagerBackendId) {
                dispatch(
                    headerShowAction({
                        data: "Backend Manager is required.",
                    })
                );
                return;
            }

            // -------------------------------
            // ⭐ Generate dynamic months array
            // -------------------------------
            const start = new Date(CaseFromDate);
            const end = new Date(CaseToDate);

            let months = [];
            let dt = new Date(start);

            while (dt <= end) {
                months.push(dt.getMonth() + 1);
                dt.setMonth(dt.getMonth() + 1);
            }

            let where = {};
            set(where, "months", months);  // <-- IMPORTANT


            if (productCategory === "CAR_LOAN") {
                set(where, "productCategory", PRODUCT_CATEGORY_TYPES_LIST[1].value);

                if (loanType) {
                    set(where, "meta.loanType", loanType);
                }
                if (usedCarLoanType) {
                    set(where, "meta.usedCarType", usedCarLoanType);
                }

                // FROM Date (Car Loan)
                if (CaseFromDate && !Number.isNaN(CaseFromDate.getTime())) {
                    set(where, "meta.loanDate.$gte", getStartOfDay(CaseFromDate));
                }

                if (CaseToDate && !Number.isNaN(CaseToDate.getTime())) {
                    set(where, "meta.loanDate.$lte", getEndOfDay(CaseToDate));
                }

            } else if (productCategory === "VEHICLE_INSURANCE") {
                set(where, "productCategory", PRODUCT_CATEGORY_TYPES_LIST[0].value);

                // Policy Type (for Insurance)
                if (insuranceType) {
                    set(where, "vehicleStatus", insuranceType);
                }

                // FROM Date (Insurance)
                if (CaseFromDate && !Number.isNaN(CaseFromDate.getTime())) {
                    set(where, "coverNotes.cn_date.$gte", getStartOfDay(CaseFromDate));
                }
                // TILL Date (Insurance)
                if (CaseToDate && !Number.isNaN(CaseToDate.getTime())) {
                    set(where, "coverNotes.cn_date.$lte", getEndOfDay(CaseToDate));
                }
            }

            // Common fields: company and agent
            if (companyId) {
                set(where, "companyId", companyId);
            }
            // if (agentId) {
            //     set(where, "agentId", agentId);
            // }
            // if (reportingManagerBackendId) {
            //     set(where, "reportingManagerId", reportingManagerId);
            // }
            if (reportingManagerBackendId) {
                set(where, "reportingManagerBackendId", reportingManagerBackendId);
            }
            // Execute the pipeline
            const {
                data: {
                    data: caseForComission,
                },
            } = await ManagerAgentMonthWiseCases({ where, months });
            setSearchResults(caseForComission);
            setOnSearchValues({
                ...values,
                months, // <-- include the generated months array
            });
        },
        [dispatch]
    );
    //to navigate to another page
    const handleRouting = (record) => {
        if (!onSearchValues?.companyId) {
            onSearchValues.companyId = record?.companyId;
        } if (!onSearchValues?.loanType) {
            onSearchValues.loanType = record?.type;
        }
        history.push({
            pathname: RoutingUtil.caseListSearch(),
            state: { filters: onSearchValues },
        });
    };


    return (
        <div>
            <Formik
                onSubmit={onSearchSubmit}
                enableReinitialize
                initialValues={filterInitialValues}
            >
                {(formikProps) => (
                    <Render
                        {...formikProps}
                        activityList={activitiesFromSearch}
                        monthTotals={searchResults?.[0]?.monthTotals || []}
                        managerTotalCases={
                            searchResults?.[0]?.managerAgentData?.[0]?.totalCases || 0
                        }
                        PRODUCT_CATEGORY_TYPES_LIST={PRODUCT_CATEGORY_TYPES_LIST}
                        VehicleStatusTypesData={VehicleStatusTypesData}
                        handleRouting={handleRouting}
                        onSearchValues={onSearchValues}
                    />
                )}
            </Formik>
        </div>
    );
}

export default BEMgrSalesReport
